import React from 'react';

const VideoBackgroundHero = () => {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hidden md:block absolute top-0 left-0 w-full h-full object-cover min-h-full min-w-full"
        style={{ objectFit: 'cover' }}
      >
        <source
          src="https://customer-assets.emergentagent.com/job_bezalel-ux-update/artifacts/74izxjw7_background-animado.mp4"
          type="video/mp4"
        />
      </video>
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-800/90 to-cyan-600/85"></div>
    </div>
  );
};

export default VideoBackgroundHero;
